import $ from 'jquery';
import { axiosInstance as axios, handleAxiosErrors } from '../_utils';
import config from '../store/_config';

export const axiosRequestCheckoutDetail = () => {
    let { url, query } = config.cart.detail;

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosRequestDeliveryOptions = () => {
    let { url, query } = config.checkout.deliveryOptions;

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosUpdateCheckout = (params) => {
    let { url, query } = config.checkout.update;

    return axios.post(
        url,
        { id: query, variables: { Input: params } },
        {
            withCredentials: true,
        }
    );
};
export const axiosUpdateShipping = (params) => {
    let { url, query } = config.checkout.updateShipping;

    return axios.post(
        url,
        { id: query, variables: { Input: params } },
        {
            withCredentials: true,
        }
    );
};

export const axiosRemoveProductAppliedDiscountCoupon = (params) => {
    let { url, query } = config.checkout.removeProductAppliedCoupon;

    return axios.post(
        url,
        { id: query, variables: params },
        {
            withCredentials: true,
        }
    );
};

export const axiosRemoveAppliedDiscountCoupon = (params) => {
    let { url, query } = config.checkout.removeAppliedCoupon;

    return axios.post(
        url,
        { id: query, variables: params },
        {
            withCredentials: true,
        }
    );
};

export const axiosUpdateDispatchLocation = (params) => {
    let { url, query } = config.checkout.updateDispatchLocation;

    return axios.post(
        url,
        { id: query, variables: { Input: params } },
        {
            withCredentials: true,
        }
    );
};

export const axiosUpdateShippingAddress = (shippingAddressID = 0) => {
    let { url, query } = config.checkout.updateShippingAddress;
    query = query.replace('{shippingAddressID}', shippingAddressID);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosUpdatePaymentMethod = (paymentMethod = '') => {
    let { url, query } = config.checkout.updateCartPaymentMethod;
    query = query.replace('{paymentMethod}', paymentMethod);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
    // return axios.post(url, { query: query }, {
    //     withCredentials: true,
    // });
};
export const axiosProcessPayment = (params) => {
    let { url } = config.checkout.processPayment;
    const postData = $.param(params);

    // Request
    return axios.post(url, postData, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        withCredentials: true,
    });
};
